import { css } from '@emotion/css';

export const FallBackStyled = css`
  .svg-background {
    width: 100%;
    height: 100%;
    position: absolute;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }

  .svg-foreground {
    height: 100%;
    width: 100%;
    padding: 20px;
    pointer-events: none;
  }
`;
